import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class GetdataService {
  authToken:any;
  headers= new Headers();

  constructor(private http:Http, private authService:AuthenticationService){  
    this.authService.RetrieveloadToken();
    
    this.headers.append('Authorization', this.authService.RetrieveloadToken());
  }

    getAllMeetingRooms(){
      return this.http.get('/fetchs/fetch_rooms',{headers:this.headers})
      .map(res => res.json());
    }
    
    getAccessToken(room_id){
      return this.http.get('/fetchs/fetch_outlookroom_byID/'+room_id,{headers:this.headers})
      .map(res => res.json());
    }
        
    renewAccessToken(graph_refresh_token,room_id){
      return this.http.get('/fetchs/renew_access_token/'+graph_refresh_token+'/'+room_id,{headers:this.headers})
      .map(res => res.json());
    }


    getMeetingsUsingAccessToken(graph_access_token,graph_user_name,room_outlook_ID){
      return this.http.get('/fetchs/fetch_events_outlook/'+graph_access_token+'/'+room_outlook_ID,{headers:this.headers})
      .map(res => res.json());
    }

    getAuthURL(){
      return this.http.get('/fetchs/auth_url',{headers:this.headers})
      .map(res => res.json());
    }

    getProfileFromLocalStorage(){
      return this.authService.RetrieveAccount()
    }

    getEventsByAccountID(account_id){
      return this.http.get('/fetchs/fetch_events_byAccountID/'+account_id,{headers:this.headers})
      .map(res => res.json());
    }

    getRoomCountByAccountID(account_id){
      return this.http.get('/fetchs/fetch_roomcount_byAccountID/'+account_id,{headers:this.headers})
      .map(res => res.json());
    }

    getMeetingData(meeting_id){
      return this.http.get('/fetchs/fetch_meeting_byID/'+meeting_id,{headers:this.headers})
      .map(res => res.json());
    }

    getAccounts(){
      return this.http.get('/fetchs/fetch_accounts',{headers:this.headers})
      .map(res => res.json());
    }
    
    getAccountNameById(accountID){
      console.log(accountID)
      return this.http.get('/fetchs/fetch_accountname_byAccountID/'+accountID,{headers:this.headers})
      .map(res => res.json());
    }

    getMeetingRoomsByAccount(room_account_ID){
      return this.http.get('/fetchs/fetch_rooms_byAccount/'+room_account_ID,{headers:this.headers})
      .map(res => res.json());
    }

    getWorkGroupsByAccount(user_account_ID){
      return this.http.get('/fetchs/fetch_workgroups_byAccountID/'+user_account_ID,{headers:this.headers})
      .map(res => res.json());
    }

    getUserByID(account_ID){
      return this.http.get('/fetchs/fetch_user_byID/'+account_ID,{headers:this.headers})
      .map(res => res.json());
    }

    getWorkGroupsByWorkgroupID(workgroup_ID){
      return this.http.get('/fetchs/fetch_workgroups_byworkgroupID/'+workgroup_ID,{headers:this.headers})
      .map(res => res.json());
    }

    getUsersUnderAccountAdmin(user_account_ID){
      return this.http.get('/users/fetch_users_byAccountID/'+user_account_ID,{headers:this.headers})
      .map(res => res.json());
    }

    getAdminUsers(){
      return this.http.get('/users/fetch_adminUsers/',{headers:this.headers})
      .map(res => res.json());
    }

    getMeetingRoombyID(roomid){
      return this.http.get('/fetchs/fetch_room_by_id/'+roomid,{headers:this.headers})
      .map(res => res.json());
    }

    getRoomNamefromIDArray(roomid_array){
      return this.http.get('/fetchs/fetch_room_name_by_id_array/'+roomid_array,{headers:this.headers})
      .map(res => res.json());
    }

    getEventByRoomID(roomid){
      return this.http.get('/fetchs/fetch_event_by_room_id/'+roomid,{headers:this.headers})
      .map(res => res.json());
    }

    getStartEndDatesForCurrentRoom(roomid){
      return this.http.get('/fetchs/fetch_event_dates_forcurrentroom/'+roomid,{headers:this.headers})
      .map(res => res.json());
    }

    getStartEndDatesForCurrentRoomURL(url){
      return this.http.get(url,{headers:this.headers})
      .map(res => res.json());
    }

    getGoogleCalendarData(calendarid){
      return this.http.get('/gcalendar/google_calendar/'+calendarid,{headers:this.headers})
      .map(res => res.json());
    }

}



// WEBPACK FOOTER //
// ./src/app/services/getdata.service.ts